import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalIncludeFutureFilesSwitch = (({
  includeFutureFiles,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <div
      className="share-include-future-files share-setting"
    >
      <Label for="inpIncludeFutureFiles" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Update share link' })}
          <HelpIcon id="share-include-future-files">
            {intl.formatMessage({ defaultMessage: 'Update share link when new files or Collections are added' })}
          </HelpIcon>
        </span>
        <div className="switch-control input-inner">
          <Input
            type="checkbox"
            name="include-future-files"
            id="inpIncludeFutureFiles"
            value={true}
            checked={includeFutureFiles}
            onChange={handleChange}
            disabled={!canUserManageShare()}
          />
          <i />
        </div>
      </Label>
    </div>
  );
});

ShareModalIncludeFutureFilesSwitch.propTypes = {
  includeFutureFiles: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalIncludeFutureFilesSwitch;
